import {
    Button,
    Divider,
    Form,
    Input,
    Modal,
    Select,
    Switch,
    notification,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import countryCodesjson from "../../services/countryCode.json";
import currency from "../../services/currency.json";
import timeZone from "../../services/timezone.json";
import { useEffect } from "react";

const { Option } = Select;
const initial_values = {
    add_pms: false,
    group_id: 0,
    hotel_address1: "",
    hotel_address2: "",
    hotel_rooms: 0,
    islive: false,
    isfor_testing: false,
    lock_company_hotel_id: 0,
    payment_processor_hotel_id: 0,
    pms_hotel_id: 0,
    pms_type: "",
    show_in_guest: false,
};

function createDynamicFields(fieldObj) {
    return (
        <Form.Item
            name={fieldObj.field_decorator}
            label={fieldObj.value}
            rules={fieldObj.rules}
        >
            <Input type={fieldObj.type} id={fieldObj.field_decorator} />
        </Form.Item>
    );
}

function AddHotel({ kiosk_prop_id, onClose }) {
    const [modalVisibility, setModalVisibility] = useState(false);
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [form] = Form.useForm();
    form.setFieldsValue(initial_values);
    const {
        status: lockCompanyStatus,
        data: lockCompanyData,
        refetch: getLockCompany,
    } = useQuery(
        "hotel-lock-company",
        async () =>
            await HTTP("/kioskProperties/getLockCompanyList", { staff_id }),
        { enabled: false },
    );

    const {
        status: paymentProcessorStatus,
        data: paymentProcessorData,
        refetch: getPaymentProcessor,
    } = useQuery(
        "hotel-payment-processor",
        async () =>
            await HTTP("/kioskProperties/getPaymentProcessorList", {
                staff_id,
            }),
        { enabled: false },
    );

    const {
        status: PMSStatus,
        data: PMSData,
        refetch: getPMS,
    } = useQuery(
        "hotel-pms",
        async () => await HTTP("/kioskProperties/getPMSList", { staff_id }),
        { enabled: false },
    );

    const {
        status: integrationStatus,
        data: integrationData,
        refetch: getIntegrations,
    } = useQuery(
        "hotel-integrations",
        async () =>
            await HTTP("/kioskProperties/getIntegrations", { staff_id }),
        { enabled: false },
    );

    const {
        status: hotelGroupStatus,
        data: hotelGroupsData,
        refetch: getHotelGroups,
    } = useQuery(
        "hotel-groups",
        async () => await HTTP("/kioskProperties/getHotelGroups", { staff_id }),
        { enabled: false },
    );

    const {
        status: hotelVarientStatus,
        data: hotelVarientsData,
        refetch: getHotelVarients,
    } = useQuery(
        "hotel-varients",
        async () => await HTTP("/kioskProperties/getVarientList", { staff_id }),
        { enabled: false },
    );

    function findCountryByCode(code) {
        const obj = countryCodesjson.find((data) => data.code === code);
        if (obj !== undefined) {
            return Object.keys(obj).length > 0 ? obj.dial_code : "-";
        } else {
            return "-";
        }
    }

    useEffect(() => {
        setModalVisibility(true);
        return () => {
            setModalVisibility(false);
        };
    }, []);
    function handleCountryChange(e) {
        const newCurrency =
            currency[
                countryCodesjson.find((item) => item.code === e)
                    ? countryCodesjson.find((item) => item.code === e).code
                    : e
            ];
        form.setFieldsValue({ currency_code: newCurrency });
    }

    async function handleSubmit(value) {
        const formData = Object.fromEntries(
            Object.entries(value).map(([key, val]) => {
                if (val == undefined) return [key, ""];
                if (
                    [
                        "group_id",
                        "lock_company_hotel_id",
                        "payment_processor_hotel_id",
                        "pms_hotel_id",
                    ].includes(key)
                ) {
                    return [key, Number(val)];
                }
                return [key, val];
            }),
        );
        console.log("formData", formData);
        const { success, message } = await HTTP(
            "/kioskProperties/createKioskPropertyHotel",
            {
                ...formData,
                staff_id,
                hotel_rooms: 0, // ask nikunj thacker about this.
                property_id: kiosk_prop_id,
            },
        );

        if (success) {
            notification["info"]({ message });
        } else {
            notification["error"]({ message });
        }
        onClose(1);
    }

    useEffect(() => {
        getHotelVarients();
        getLockCompany();
        getPaymentProcessor();
        getPMS();
        getHotelGroups();
        getIntegrations();
    }, []);

    return (
        <>
            <Modal
                open={modalVisibility}
                destroyOnClose
                title=""
                footer=""
                onClose={onclose}
                onCancel={onClose}
            >
                <Form onFinish={handleSubmit} form={form}>
                    <Divider orientation="left" orientationMargin="0">
                        Hotel Details
                    </Divider>
                    <Form.Item
                        label="Hotel Name"
                        name="hotel_name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel Name..!",
                            },
                        ]}
                    >
                        <Input id="hotel_name" placeholder="Hotel Name" />
                    </Form.Item>
                    <Form.Item label="Hotel Group" name="group_id">
                        <Select
                            placeholder="Hotel Group"
                            id="group_id"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            loading={hotelGroupStatus != "success"}
                        >
                            {hotelGroupsData?.data?.map((grp) => (
                                <Option
                                    key={Number(grp.id)}
                                    val={Number(grp.id)}
                                >
                                    {grp.group_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Hotel PMS" name="pms_hotel_id">
                        <Select
                            placeholder="Hotel PMS"
                            id="pms_hotel_id"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            loading={PMSStatus !== "success"}
                        >
                            {PMSData?.data?.map((grp) => (
                                <Option
                                    key={Number(grp.id)}
                                    val={Number(grp.id)}
                                >
                                    {grp.pms_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Payment Processor"
                        name="payment_processor_hotel_id"
                    >
                        <Select
                            placeholder="Payment Processor"
                            id="payment_processor_hotel_id"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            loading={paymentProcessorStatus != "success"}
                        >
                            {paymentProcessorData?.data?.map((grp) => (
                                <Option
                                    key={Number(grp.id)}
                                    val={Number(grp.id)}
                                >
                                    {grp.payment_processor_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Lock Company"
                        name="lock_company_hotel_id"
                    >
                        <Select
                            placeholder="Lock Company"
                            id="lock_company_hotel_id"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            loading={lockCompanyStatus != "success"}
                        >
                            {lockCompanyData?.data?.map((grp) => (
                                <Option
                                    key={Number(grp.id)}
                                    val={Number(grp.id)}
                                >
                                    {grp.lock_company_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Country"
                        name="person_country_code"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Country..!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Country"
                            id="person_country_code"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            onChange={(e) => handleCountryChange(e)}
                        >
                            {countryCodesjson.map((countryCode) => (
                                <Option
                                    key={countryCode.code}
                                    value={countryCode.code}
                                >
                                    {`${countryCode.name} (+${countryCode.dial_code})`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="currency_code"
                        label="Currency"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Currency..!",
                            },
                        ]}
                    >
                        <Input
                            id="currency_code"
                            disabled
                            placeholder="Currency"
                        ></Input>
                    </Form.Item>
                    <Form.Item
                        name="tz"
                        label="Time Zone"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Time Zone..!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Time Zone"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            onChange={(e) => {
                                const tz_id = timeZone.find(
                                    (t) => t.value == e,
                                );
                                form.setFieldsValue({ tz_id: tz_id.utc[0] });
                            }}
                        >
                            {timeZone.map((tz) => (
                                <Option key={tz.value} value={tz.value}>
                                    {tz.text}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.person_country_code !==
                            currentValues.person_country_code
                        }
                    >
                        {({ getFieldValue }) => (
                            <Form.Item
                                label="Phone"
                                name="hotel_phone"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Add Hotel Phone..!",
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Phone"
                                    addonBefore={
                                        <span
                                            disabled
                                            className="ant-input-disabled"
                                        >
                                            {getFieldValue(
                                                "person_country_code",
                                            ) &&
                                                isNaN(
                                                    getFieldValue(
                                                        "person_country_code",
                                                    ),
                                                ) &&
                                                "+" +
                                                    findCountryByCode(
                                                        getFieldValue(
                                                            "person_country_code",
                                                        ),
                                                    )}
                                        </span>
                                    }
                                    id="hotel_phone"
                                />
                            </Form.Item>
                        )}
                    </Form.Item>
                    <Form.Item
                        label="Hotel Address"
                        name="hotel_address"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel Address..!",
                            },
                        ]}
                    >
                        <TextArea
                            id="hotel_address"
                            placeholder="Hotel Address"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Hotel Address 1"
                        name="hotel_address1"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel Address 1..!",
                            },
                        ]}
                    >
                        <TextArea
                            id="hotel_address1"
                            placeholder="Hotel Address 1"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Hotel Address 2"
                        name="hotel_address2"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel Address 2..!",
                            },
                        ]}
                    >
                        <TextArea
                            id="hotel_address2"
                            placeholder="Hotel Address 2"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Street Address"
                        name="street_address"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Street Address..!",
                            },
                        ]}
                    >
                        <Input
                            id="street_address"
                            placeholder="Street Address"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Hotel City"
                        name="hotel_city"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel City..!",
                            },
                        ]}
                    >
                        <Input id="hotel_city" placeholder="Hotel City" />
                    </Form.Item>
                    <Form.Item
                        label="Hotel State"
                        name="hotel_state"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel State..!",
                            },
                        ]}
                    >
                        <Input id="hotel_state" placeholder="Hotel State" />
                    </Form.Item>
                    <Form.Item
                        label="Hotel Zip Code"
                        name="hotel_zip"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel Zip Code..!",
                            },
                        ]}
                    >
                        <Input id="hotel_zip" placeholder="Hotel Zip Code" />
                    </Form.Item>
                    <Form.Item
                        label="Hotel Email"
                        name="hotel_email"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Hotel Email..!",
                            },
                        ]}
                    >
                        <Input id="hotel_email" placeholder="Hotel Email" />
                    </Form.Item>
                    <Divider orientation="left" orientationMargin="0">
                        Admin User Details
                    </Divider>
                    <Form.Item
                        name="person_first_name"
                        label="First Name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter First Name..!",
                            },
                        ]}
                    >
                        <Input
                            id="person_first_name"
                            placeholder="First Name"
                        />
                    </Form.Item>
                    <Form.Item
                        name="person_last_name"
                        label="Last Name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Last Name..!",
                            },
                        ]}
                    >
                        <Input id="person_last_name" placeholder="Last Name" />
                    </Form.Item>
                    <Form.Item
                        name="staff_email"
                        label="Email"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Email..!",
                            },
                            {
                                type: "email",
                                message: "Please Enter Valid Email..!",
                            },
                        ]}
                    >
                        <Input id="staff_email" placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.person_country_code !==
                            currentValues.person_country_code
                        }
                    >
                        {({ getFieldValue }) => (
                            <Form.Item
                                label="Phone"
                                name="staff_phone"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Add Hotel Phone..!",
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Phone"
                                    addonBefore={
                                        <span
                                            disabled
                                            className="ant-input-disabled"
                                        >
                                            {getFieldValue(
                                                "person_country_code",
                                            ) &&
                                                isNaN(
                                                    getFieldValue(
                                                        "person_country_code",
                                                    ),
                                                ) &&
                                                "+" +
                                                    findCountryByCode(
                                                        getFieldValue(
                                                            "person_country_code",
                                                        ),
                                                    )}
                                        </span>
                                    }
                                    id="staff_phone"
                                />
                            </Form.Item>
                        )}
                    </Form.Item>
                    <Form.Item
                        name="add_pms"
                        label="Add To PMS?"
                        valuePropName="checked"
                    >
                        <Switch id="add_pms" />
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.add_pms !== currentValues.add_pms
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("add_pms") == 1 && (
                                <>
                                    <Form.Item
                                        label="PMS Type"
                                        name="pms_type"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Select PMS type..!",
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.children
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase(),
                                                    )
                                            }
                                        >
                                            {integrationData?.data.map((i) => (
                                                <Option key={i.id} value={i.id}>
                                                    {i.name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        shouldUpdate={(
                                            prevValues,
                                            currentValues,
                                        ) =>
                                            prevValues.pms_type !==
                                            currentValues.pms_type
                                        }
                                    >
                                        {({ getFieldValue }) => (
                                            <>
                                                {integrationData?.data.find(
                                                    (i) =>
                                                        i.id ==
                                                        getFieldValue(
                                                            "pms_type",
                                                        ),
                                                )?.formItems.length > 0 &&
                                                    integrationData?.data
                                                        .find(
                                                            (i) =>
                                                                i.id ==
                                                                getFieldValue(
                                                                    "pms_type",
                                                                ),
                                                        )
                                                        ?.formItems.map((i) =>
                                                            createDynamicFields(
                                                                i,
                                                            ),
                                                        )}
                                            </>
                                        )}
                                    </Form.Item>
                                </>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        name="contract_plan"
                        label="Varient"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Varient..!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Varient"
                            id="contract_plan"
                            showSearch
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            loading={hotelVarientStatus != "success"}
                        >
                            {hotelVarientsData?.data?.map((v) => (
                                <Option key={v.id} value={v.id}>
                                    {v.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="isfor_testing"
                        label="Testing Hotel?"
                        valuePropName="checked"
                    >
                        <Switch id="isfor_testing" />
                    </Form.Item>
                    <Form.Item
                        name="islive"
                        label="Live Hotel?"
                        valuePropName="checked"
                    >
                        <Switch id="islive" />
                    </Form.Item>
                    <Form.Item
                        name="show_in_guest"
                        label="Show In Find My Reservations?"
                        valuePropName="checked"
                    >
                        <Switch id="show_in_guest" />
                    </Form.Item>
                    <Form.Item name="tz_id" className="hidden">
                        <Input />
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export { AddHotel };
